module.exports = __webpack_public_path__ + "deliverBlack_icon.png";